export async function initSingleProduct() {
    // init thumbnails
    document.querySelectorAll('[data-spwk-product-thumbnail-switch]').forEach((button) => {
        button.addEventListener('click', () => {
            const targetSwiperElement = document.getElementById(button.dataset.spwkProductThumbnailSwitch),
                targetSwiper = targetSwiperElement?.swiper;

            if (targetSwiper) {
                targetSwiper.slideTo(Number(button.dataset.spwkProductThumbnailIndex));
            }
        });
    });
}
